import { post } from "../utils/ApiUtil";
import { Global } from "../Global";

export interface GetLatestSearchedKeywordsRequest {  
} // 空对象

export interface DeleteAllLatestSearchedKeywordsRequest {  
} // 空对象

export interface GetRecommendSearchedKeywordsRequest {  
} // 空对象
  
export const getLatestSearchedKeywords = async (params: GetLatestSearchedKeywordsRequest): Promise<string[]>=>{
    if(Global.isMockMode() ){
       return Promise.resolve(["抖音短视频", "视频创作", "前端开发", "后端开发", "PPT设计"]);
    }
    const resultOrErrorCode = await post<GetLatestSearchedKeywordsRequest, string[]>('/mix/getLatestSearchedKeywords', params);
    if(typeof resultOrErrorCode === 'string'){
      return [];
    }
    return resultOrErrorCode;
}


export const deleteAllLatestSearchedKeywords = async (params: DeleteAllLatestSearchedKeywordsRequest): Promise<boolean>=>{
  if(Global.isMockMode() ){
     return Promise.resolve(true);
  }
  const resultOrErrorCode = await post<DeleteAllLatestSearchedKeywordsRequest, boolean>('/mix/deleteAllLatestSearchedKeywords', params);
  if(typeof resultOrErrorCode === 'string'){
    return false;
  }
  return resultOrErrorCode;
}

const getBasicConfigs = async (): Promise<Map<string, string>>=>{
  if(Global.isMockMode() ){
      return Promise.resolve(Global.getMockData("getBasicConfigs"));
  }
  const resultOrErrorCode = await post<{}, any>('/mix/getBasicConfigs', {});
  // 如果返回的是错误码（非 JSON string），返回空 Map
  if(typeof resultOrErrorCode === 'string' && !resultOrErrorCode.trim().startsWith("{")){
    return new Map<string, string>();
  }
  // API 返回的是 JSON string，解析后转换为 Map
  let configObj: any = {};
  if (typeof resultOrErrorCode === 'string') {
    try {
      configObj = JSON.parse(resultOrErrorCode);
    } catch (e) {
      console.error('解析 JSON 失败:', e);
      return new Map<string, string>();
    }
  } else if (resultOrErrorCode && typeof resultOrErrorCode === 'object') {
    configObj = resultOrErrorCode;
  }
  
  const configMap = new Map<string, string>();
  Object.keys(configObj).forEach(key => {
    const val = configObj[key];
    if (val !== null && typeof val === 'object') {
      configMap.set(key, JSON.stringify(val));
    } else {
      configMap.set(key, String(val));
    }
  });
  return configMap;
}
 

const sendPhoneCode = async (phone: string, captchaToken?: string): Promise<boolean>=>{
  if(Global.isMockMode() ){
     return Promise.resolve(true);
  }
  const resultOrErrorCode = await post<{phone: string; captchaToken?: string}, boolean>(
    '/mix/sendPhoneCode',
    {
      phone,
      ...(captchaToken ? { captchaToken } : {}),
    },
  );
  if(typeof resultOrErrorCode === 'string'){
    return false;
  }
  return resultOrErrorCode;
}


const getPhoneAreaCode = async () => {
  return [
      { code: 'CN', dialCode: '+86', name: '中国' },
      { code: 'HK', dialCode: '+852', name: '中国香港' },
      { code: 'MO', dialCode: '+853', name: '中国澳门' },
      { code: 'TW', dialCode: '+886', name: '中国台湾' },
      { code: 'US', dialCode: '+1', name: '美国' },
      { code: 'CA', dialCode: '+1', name: '加拿大' },
      { code: 'GB', dialCode: '+44', name: '英国' },
      { code: 'AU', dialCode: '+61', name: '澳大利亚' },
      { code: 'NZ', dialCode: '+64', name: '新西兰' },
      { code: 'JP', dialCode: '+81', name: '日本' },
      { code: 'KR', dialCode: '+82', name: '韩国' },
      { code: 'SG', dialCode: '+65', name: '新加坡' },
      { code: 'MY', dialCode: '+60', name: '马来西亚' },
      { code: 'TH', dialCode: '+66', name: '泰国' },
      { code: 'VN', dialCode: '+84', name: '越南' },
      { code: 'IN', dialCode: '+91', name: '印度' },
      { code: 'ID', dialCode: '+62', name: '印度尼西亚' },
      { code: 'PH', dialCode: '+63', name: '菲律宾' },
      { code: 'DE', dialCode: '+49', name: '德国' },
      { code: 'FR', dialCode: '+33', name: '法国' },
      { code: 'IT', dialCode: '+39', name: '意大利' },
      { code: 'ES', dialCode: '+34', name: '西班牙' },
      { code: 'RU', dialCode: '+7', name: '俄罗斯' },
      { code: 'AE', dialCode: '+971', name: '阿联酋' },
      { code: 'SA', dialCode: '+966', name: '沙特阿拉伯' },
      { code: 'BR', dialCode: '+55', name: '巴西' },
      { code: 'MX', dialCode: '+52', name: '墨西哥' },
      { code: 'ZA', dialCode: '+27', name: '南非' },
    ];
};


export const MixApi = {
  getBasicConfigs, 
  sendPhoneCode,
  getPhoneAreaCode
}